import React from 'react'

import UserStoryForm from 'app/domains/common/UserStoryForm'
import ModalBody from 'app/components/Modal/ModalBody'

import './styles.scss'
const bc = 'feed-stories-list-item-menu-popup'

const FeedStoriesListItemMenuPopup: React.FC<any> = ({
  onRequestClose,
  question,
  initialValues,
  customSubmit,
  extraBlock,
  whiteCardClassName,
  activityDescription,
  ...props
}) => {
  const renderStoryForm = () => (
    <ModalBody onRequestClose={onRequestClose} className={`${bc}__wrapper`}>
      {/* {extraBlock && React.createElement(extraBlock, { ...props })} */}
      <UserStoryForm
        question={question}
        className={bc}
        initialValues={initialValues}
        customSubmit={customSubmit}
        activityName={props.activity.get('name')}
        activityDay={props.activity.get('day')}
        {...props}
      />
    </ModalBody>
  )

  const renderEditForm = () => (
    <ModalBody onRequestClose={onRequestClose} className={`${bc}__wrapper`}>
      <UserStoryForm
        onRequestClose={onRequestClose}
        activityDescription={activityDescription}
        className={bc}
        buttonTitle="Save Story"
        title="Edit Story"
        question={question}
        editOrCreateStory
        initialValues={{
          story: initialValues.get('story'),
          storyId: initialValues.get('storyId'),
        }}
        customSubmit={customSubmit}
        whiteCardClassName={whiteCardClassName}
      />
    </ModalBody>
  )

  return initialValues.get('isEdit') ? renderEditForm() : renderStoryForm()
}

export default FeedStoriesListItemMenuPopup
